// extracted by css-extract-rspack-plugin
export default {"clear":"RVKpGk","stars":"o3n6LM","value":"Gm_VnG","desc":"SslBcY","highlight":"Y54oC0"};